import { render, staticRenderFns } from "./DataInfoForm.vue?vue&type=template&id=4eff8cb8&"
import script from "./DataInfoForm.vue?vue&type=script&lang=js&"
export * from "./DataInfoForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports